var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.globalState.blocked)?_c('div',{staticClass:"global-loader"},[_c('v-progress-circular',{staticClass:"spinner",attrs:{"size":64,"color":"#FF530D","indeterminate":""}}),_c('img',{staticClass:"callout-logo",attrs:{"src":require(`@/assets/images/icon_dark.png`),"alt":"logo"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }